<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="container-fluid">
        <!-- HEADER -->
        <div class="container-fluid my-3">
            <div class="top-card">
                <div class="row w-100 mx-auto d-flex">
                    <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
                        <span>Upload Shortage File</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- UPLOAD CARD -->
        <div class="card search-card">
            <div class="row align-items-center">
                <!-- Select Date Label -->
                <div class="col-12 col-md-2 my-2">
                    <p class="enter-title mb-0">Select Date</p>
                </div>

                <!-- Date Picker -->
                <div class="col-12 col-md-3 my-2">
                    <p-calendar [(ngModel)]="selectedDate" dateFormat="dd-mm-yy" [showIcon]="true"
                        placeholder="Select Date" [style]="{ width: '100%', 'font-size': '12px' }" appendTo="body"
                        [disabled]="isUploading">
                    </p-calendar>
                </div>

                <!-- File Upload -->
                <div class="col-12 col-md-3 my-2">
                    <input type="file" class="form-control" accept=".xlsx,.xls,.csv" (change)="onFileSelected($event)"
                        [disabled]="isUploading" />
                </div>

                <!-- Upload Button -->
                <div class="col-12 col-md-2 my-2">
                    <button type="button" class="btn btn-submit w-100" (click)="uploadFile()"
                        [disabled]="!selectedFile || !selectedDate || isUploading">
                        <span *ngIf="!isUploading">Upload</span>
                        <span *ngIf="isUploading">
                            <i class="fa fa-spinner fa-spin"></i> Uploading...
                        </span>
                    </button>
                </div>

                <!-- Clear Button -->
                <div class="col-12 col-md-2 my-2">
                    <button type="button" class="btn btn-clear w-100" (click)="clearFilter()" [disabled]="isUploading">
                        Clear
                    </button>
                </div>
            </div>

            <!-- In Progress Message -->
            <div class="row" *ngIf="isUploading && !selectedFile">
                <div class="col-12">
                    <div class="alert alert-warning mt-2 mb-0 py-2" style="font-size: 13px;">
                        <i class="fa fa-info-circle me-2"></i>
                        <span *ngIf="totalRecords > 0">
                            A file is currently being processed: <strong>{{ processedRecords }}</strong> of <strong>{{
                                totalRecords }}</strong> records processed (<strong>{{ remainingRecords }}</strong>
                            remaining).
                        </span>
                        <span *ngIf="totalRecords === 0">
                            A file is currently being processed. You can navigate away and return later to check the
                            result.
                        </span>
                    </div>
                </div>
            </div>

            <!-- Selected File Info -->
            <div class="row" *ngIf="selectedFile">
                <div class="col-12">
                    <div class="alert alert-info mt-2 mb-0 py-2" style="font-size: 13px;">
                        <strong>Selected File:</strong> {{ selectedFile.name }}
                        ({{ (selectedFile.size / 1024).toFixed(2) }} KB)
                    </div>
                </div>
            </div>
        </div>

        <!-- LOGS TABLE -->
        <div class="card mt-3 mx-2 shadow-sm border-0">
            <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
                <h5 class="mb-0 fw-bold text-dark">Upload Logs</h5>
                <button type="button" class="btn btn-sm btn-outline-primary refresh-btn" (click)="refreshLogs()"
                    [disabled]="isLoadingLogs">
                    <i class="fa fa-refresh" [class.fa-spin]="isLoadingLogs"></i> Refresh
                </button>
            </div>
            <div class="card-body p-0">
                <!-- Loading State -->
                <div *ngIf="isLoadingLogs" class="text-center py-5">
                    <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
                    <p class="mt-3">Loading logs...</p>
                </div>

                <!-- No Data State -->
                <div *ngIf="!isLoadingLogs && logs.length === 0" class="text-center py-5">
                    <i class="fa fa-inbox fa-3x text-muted"></i>
                    <p class="mt-3 text-muted">No logs found</p>
                </div>

                <!-- Table -->
                <div *ngIf="!isLoadingLogs && logs.length > 0" class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead class="table-light">
                            <tr>
                                <th class="ps-4">#</th>
                                <th>File Name</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th class="pe-4 text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let log of logs | slice:first:(first + rows); let i = index">
                                <td class="ps-4 align-middle">{{ first + i + 1 }}</td>
                                <td class="align-middle fw-semibold text-primary">{{ log.file_name }}</td>
                                <td class="align-middle text-muted">{{ log.shortage_date }}</td>
                                <td class="align-middle">
                                    <span [ngClass]="getStatusClass(log.status)">
                                        {{ log.status }}
                                    </span>
                                </td>
                                <td class="pe-4 text-center align-middle">
                                    <div class="d-flex justify-content-center gap-2">
                                        <button type="button" class="btn btn-xs btn-outline-primary action-btn"
                                            (click)="downloadFile(log.file_path)" title="Download File"
                                            [disabled]="log.status === 'processing'">
                                            <i class="fa fa-download me-1"></i> Download
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Pagination -->
                <div *ngIf="!isLoadingLogs && logs.length > 0"
                    class="p-3 border-top d-flex justify-content-between align-items-center">
                    <p class="text-muted mb-0 small">Showing {{ first + 1 }} to {{ (first + rows) > logs.length ?
                        logs.length : (first + rows) }} of <strong>{{ logs.length }}</strong> records</p>
                    <p-paginator [first]="first" [rows]="rows" [totalRecords]="logs.length"
                        [rowsPerPageOptions]="[10, 20, 30]" (onPageChange)="onPageChange($event)">
                    </p-paginator>
                </div>
            </div>
        </div>

    </div>
</div>